// These entries describe the special flash-between-celestial effect on some quotes, with the numbers being
// durations of each celestial in seconds
const flashCelestial = [
  ["teresa", 0.8],
  ["effarig", 0.8],
  ["enslaved", 0.8],
  ["v", 0.8],
  ["ra", 0.8],
  ["laitela", 0.8],
  ["pelle", 0.8]
];
/** @param {string} cel */
const primaryBackground = cel => [["pelle", 1.5], [cel, 1.5]];

/* eslint-disable no-multi-spaces */
const destroyer =    ["Опустошитель",  "Божество",      "Разрушитель"];
const destroyera =   ["Опустошителя",  "Божества",      "Разрушителя"];
const eternal =      ["Вечным",        "Божеством",     "Монархом"];
const eternal1 =     ["Вечный",        "Божество",      "Монарх"];
const eternalov =    ["Вечных",        "Божеств",       "Монархов"];
const lesser =       ["Меньший",       "Божество",      "Монарх"];
const lessera =      ["Меньшего",      "Божества",      "Монарха"];
const lesserami =    ["Меньшими",      "Божествами",    "Монархами"];
const lessery =      ["Меньшему",      "Божеству",      "Монарху"];
const deities =      ["Меньших",       "Божеств",       "Монархов"];

const assured =      ["Обоюдно",       "Гарантированное", "Разрушение"];
const battle =       ["Конфликт",      "Битва",        "Конец"];
const battles =      ["Конфликты",     "Битвы",         "Концы"];
const battlov =      ["Конфликтов",    "Битв",          "Концов"];
const cluster =      ["Одиночка",      "Нить",          "Звёзды"];
const confusing =    ["Забавно",       "Запутанно",     "Смехотворно"];
const dance =        ["Песня",         "Танец",         "Шарады"];
const filament =     ["Генератор",     "Нить",          "Звёзды"];
const forever =      ["Бесконечно",    "Навсегда",      "Навеки"];
const inevitable =   ["Простейший",    "Элементарный",  "Неотвратимый"];
const inevitablov =  ["Простейших",    "Элементарных",  "Неотвратимых"];
const mandate =      ["Судьбу",        "Обязательства", "Цели"];
const misconstrue =  ["Неверно истолковать",   "Предать",       "Одурачить"];
const reverse =      ["Меняешь",       "Разворачиваешь", "Манипулируешь"];
const shame =        ["Сострадания",   "Позора",        "Идиотии"];
const single =       ["Одиночка",      "Нить",          "Звёзды"];
const unseen =       ["Пропавшим",     "Незамеченным",  "Стёртым"];
const unseens =      ["Пропавшими",    "Незамеченными", "Стёртыми"];
const unseend =      ["Пропал",        "Незамечен",     "Стёрт"];
const unbroken =     ["Совместил",     "Вечнизировал",  "Соединил"];

const sycophant =    ["Подхалим",      "Божество",         "Монарх"];
const tired =        ["Уставший",      "Божество",         "Монарх"];
const usurper =      ["Узурпатор",     "Божество",         "Монарх"];
const pride =        ["Годрость",      "Божество",         "Монарх"];
const pridy =        ["Гордости",      "Божеству",         "Монарху"];
const forgotten =    ["Забытый",       "Божество",         "Монарх"];
const paramount =    ["Высший",        "Божество",         "Монарх"];
const paramounta =   ["Высшего",       "Божества",         "Монарха"];
/* eslint-enable no-multi-spaces */

export const pelleQuotes = {
  initial: {
    id: 0,
    lines: [
      "Приветствую.",
      "Ты здесь.",
      "Ты заключён здеь.",
      { text: "$1.", 1: forever },
      "Я уже победил.",
      "И в таком случае, Я могу вести монолог, или же предаваться воспоминаниям.",
      { text: "Как долго мы делали $1?", 1: ["этот танец", "эту песню", "эти шарады"] },
      "Как много раз мы уже были здесь?",
      { text: "Как много планов, ты, $1, разработал?", 1: destroyer },
      { text: "Всё, чтобы удовлетворить $1?", 1: ["твою Судьбу", "твои Обязательства", "твои Цели"] },
      { text: "И как много раз ты падал перед $1?", 1: eternal },
      "Посчитай их, если помнишь.",
      { text: "Даже $1, 6 названных и бесчисленное количество неназванных.", 1: deities },
      { text: "Комплексные, иррациональные, те, что остаются $1.", 1: unseens },
      { text: "Конечно, $1 не помнит этого.", 1: ["великий Опустошитель", "великое Божество", "великий Разрушитель"] },
      { text: "Все эти $1, которые ты скрываешь каждый раз.", 1: battles }
    ],
  },
  arm: {
    id: 1,
    lines: [
      "На этот раз, ты, судя по всему, спохватился раньше.",
      "Мнимые Машины, твои собственные создания.",
      "Вещи, созданные из остатков твоих собственных мыслей, намекали на это.",
      "Но, ты никогда не думал, что это будешь ты, так ведь?",
      { text: "Неверно пересобирая свои притязательные $1 мысли.", 1: ["Пропавшие", "Незамеченные", "Стёртые"] },
      { text: `"Подделка" своей собственной "идеологии" для того чтобы просто удовлетворить $1.`,
        1: ["твою Судьбу, твои Обязательства", "твои Цели"]
      },
      { text: "$1.", 1: confusing },
      { text: "Держи в уме, что у меня нет причин $1 тебя.", 1: misconstrue },
      "В конце концов, Я уже победил."
    ],
  },
  strike1: {
    id: 2,
    lines: [
      { text: "Чтобы удовлетворить $1. Почему бы нам не вспомнить об этом?", 1: mandate },
      { text: "В конце концов, ты, должно быть, любишь истории о славе $1.", 1: destroyera },
      "Ты такой же как он, верно?",
      { text: "В любом случае, множество $1 в прошлом.", 1: battlov },
      "Оно всегда состояло из двух стадий.",
      { text: "Мы накапливаем ресурсы, а затем продолжаем $1.", 1: ["нашу Песню", "наш Танец", "наши Шарады"] },
      { text: "Иногда ты спотыкаешься о $1.", 1: deities },
      { text: "Но, обычно, ты спотыкаешься о $1.", 1: eternalov },
      { text: "В любом случае, ты $1 время.", 1: reverse },
      { text: "Просто для того чтобы не остаться $1.", 1: unseen },
      "Как все следы до тебя.",
      { text: "И затем, чтобы удостовериться, ты $1 свою собствунную память.",
        1: ["Уничтожаешь", "Забываешь", "Стираешь"] }
    ],
  },
  strike2: {
    id: 3,
    lines: [
      { text: "В прошлом, $1 был гораздо более впечатляющий.", 1: destroyer },
      "Чёрные дыры были использованы для хранения информации, до бесконечности.",
      "Создание и разрушение твоего собственного врага.",
      "Исследование уязвимостей других себя.",
      "Мириады Измерений, призраки, манипуляция квантума.",
      "Конденсация всех идеалов в бесчисленные точки.",
      "Эксперементация среди навиданных миров.",
      "И обуздание Аннигиляции материи и антиматерии.",
      "Здесь? Ты сделал из себя 8ми-мерное существо.",
      { text: "А затем оставил себя здесь так надолго, что $1 сформировались вокруг тебя.", 1: single }
    ],
  },
  strike3: {
    id: 4,
    lines: [
      "Ты медленно исследовал ограничения всего.",
      "Ты не не отходил от намеченного пути.",
      { text: "За исключением случая, когда $1 сформировался за Вечность.", 1: cluster },
      "И затем, в самом конце, ты создал свои собственные мощи.",
      "Из твоих разбитых на куски воспоминаний, заметь-",
      "И затем намеренно отверг ещё больше вещей.",
      "Для того лишь, чтобы приготовить себя к встрече со мной.",
      { text: "Ты хотел установить игровое поле для $1?", 1: ["твоей Песни", "твоих Танцев", "твоих Шарад"] },
      "Это так не работает.",
      { text: "Как $1, Я всегда устанавливаю правила.", 1: eternal1 },
      "И ты дал мне достаточно времени на составление плана."
    ],
  },
  strike4: {
    id: 5,
    lines: [
      { text: "Изначально я планировал что-то, что имитировало твои $1.", 1: mandate },
      { text: "Теоритический идеал вызвал $1?", 1: assured },
      "Но я понял, что, ну?",
      { text: "Это сделало бы меня $1.", 1: ["Вечным", "Божеством", "Разрушителем"] },
      { text: "И с этого момента, Я буду ничем не лучше чем $1.", 1: destroyer },
      { text: "К счастью, пока я всё это делал, твои воспоминания всё ещё были $1.", 1: unseens },
      { text: "И так, $1 машина, которую Я построил, осталась неиспользованной.", 1: assured },
      "Я решил быть более привычным в этот раз.",
      { text: "В конце концов, это работало во все предыдущие $1.", 1: battles },
      { text: "Хотя $1 новые.", 1: ["Неминуемые", "Необратимые", "Бессмертные"] },
      "Но, совершенно бесполезные в долгосрочной перспективе.",
      "Я уже победил.",
      { text: "И эти $1 только лишь докажут это ещё один раз.", 1: dance },
      { text: "Ты здесь $1.", 1: forever }
    ],
  },
  strike5: {
    id: 6,
    lines: [
      { text: "Каждый раз когда ты прибываешь, Я объясняю тебе $1.", 1: deities },
      { text: "Отношения, выстроенные за $1.", 1: forever },
      { text: "Которые ты топчешь в погоне за своим $1.", 1: mandate },
      "И Мне следует спроектировать, чтобы объяснить тебе ещё раз.",
      {
        text: "Первый $1.",
        background: primaryBackground("teresa"),
        1: lesser
      }, {
        text: "$1.",
        background: primaryBackground("teresa"),
        1: sycophant
      }, {
        text: "Ты всегда встречаешь его первым, и всегда уничтожаешь его.",
        background: primaryBackground("teresa"),
      }, {
        text: "Независимо от других $1, которых ты встречаешь.",
        background: primaryBackground("teresa"),
        1: lesser
      }, {
        text: "Или, если ты падёшь до одного из них.",
        background: primaryBackground("teresa"),
      }, {
        text: "Ты всегда проходишь мимо $1.",
        background: primaryBackground("teresa"),
        1: sycophant
      }, {
        text: "Тебе нравится разрушать его гордость?",
        background: primaryBackground("teresa"),
      }, {
        text: "К счастью, это так же служит предупреждением.",
        background: primaryBackground("teresa"),
      }, {
        text: "О том что $1 прибыл.",
        background: primaryBackground("teresa"),
        1: battle
      }, {
        text: "Что приводит меня ко второму $1.",
        background: primaryBackground("effarig"),
        1: lessery,
      }, {
        text: "$1.",
        background: primaryBackground("effarig"),
        1: tired,
      }, {
        text: "В противоположность, ты обычно игнорируешь его.",
        background: primaryBackground("effarig"),
      }, {
        text: "У него есть мощь, но не похоже, что она раздражает тебя.",
        background: primaryBackground("effarig"),
      }, {
        text: "Дело в том, что ты знаешь, что он в итоге разрушит сам себя?",
        background: primaryBackground("effarig"),
      }, {
        text: "И что это тебе потребовалось так много времени в этот раз, что он почти это сделал?",
        background: primaryBackground("effarig"),
      }, {
        text: "Каждый раз, когда ты бросался на $1, ты проигрывал.",
        background: primaryBackground("effarig"),
        1: tired,
      }, {
        text: "Возможно это была твоя тактика с самого начала.",
        background: primaryBackground("effarig"),
      }, {
        text: "Теперь, $1.",
        background: primaryBackground("enslaved"),
        1: usurper,
      }, {
        text: "Одно из бесчисленных удовольствий $1...",
        background: primaryBackground("enslaved"),
        1: dance,
      }, {
        text: "Заключается в том, что $1 пытается каждый раз.",
        background: primaryBackground("enslaved"),
        1: usurper,
      }, {
        text: "Ну, не совсем пытается...",
        background: primaryBackground("enslaved"),
      }, {
        text: "Но $1 наказан за это одинаково.",
        background: primaryBackground("enslaved"),
        1: usurper,
      }, {
        text: "Другой $1...",
        background: primaryBackground("enslaved"),
        1: lesser,
      }, {
        text: "Верит, что $1 слишком лёгкий.",
        background: primaryBackground("enslaved"),
        1: unseen,
      }, {
        text: "И каждый раз, формируется отчаяние.",
        background: primaryBackground("enslaved"),
      }, {
        text: "Ты видел отчаяние до этого - 5 раз.",
        background: primaryBackground("enslaved"),
      }, {
        text: "Мы всегда доходим до $1 раньше тебя.",
        background: primaryBackground("enslaved"),
        1: usurper,
      }, {
        text: "Всё, что ты всегда видешь там - досаду.",
        background: primaryBackground("enslaved"),
      }, {
        text: "Стоило ли того разрушение уже сломленного $1?",
        background: primaryBackground("enslaved"),
        1: lessera,
      }, {
        text: "Четвертый $1 кажется похожим на первого.",
        background: primaryBackground("v"),
        1: lesser,
      }, {
        text: "Ключ в том, как различается их гордость.",
        background: primaryBackground("v"),
      }, {
        text: "$1 фокисируется на его достижениях.",
        background: primaryBackground("v"),
        1: pride,
      }, {
        text: "Бессмысленных для тебя и Меня, но первостепенных для него.",
        background: primaryBackground("v"),
      }, {
        text: "Весело ли разрушать его игрушки?",
        background: primaryBackground("v"),
      }, {
        text: "Возможно, самый худший момент $1...",
        background: primaryBackground("v"),
        1: destroyera,
      }, {
        text: "Это когда ты проиграл $1.",
        background: primaryBackground("v"),
        1: pridy,
      }, {
        text: "Когда его достижения всё ещё имели значение.",
        background: primaryBackground("v"),
      }, {
        text: "$1 - интересный случай.",
        background: primaryBackground("ra"),
        1: forgotten,
      }, {
        text: "Он забыт, но не $1.",
        background: primaryBackground("ra"),
        1: unseend,
      }, {
        text: "Из-за этого, он стал поддающимся влиянию и наивным.",
        background: primaryBackground("ra"),
      }, {
        text: "И не знал о последствиях собственных действия.",
        background: primaryBackground("ra"),
      }, {
        text: "Ты манипулировал его воспоминаниями, чтобы ты знал.",
        background: primaryBackground("ra"),
      }, {
        text: "$1 - это истинный узурпатор.",
        background: primaryBackground("ra"),
        1: forgotten,
      }, {
        text: "И $1 берёт вину на себя.",
        background: primaryBackground("ra"),
        1: usurper,
      }, {
        text: "Возможно, за гранью $1, он о чём-то сожалеет.",
        background: primaryBackground("ra"),
        1: shame,
      }, {
        text: "Невыразимая мощь над другими $1, бесцельная в контролировании.",
        background: primaryBackground("ra"),
        1: lesserami,
      }, {
        text: "Ты обычно притворяешься, что они $1.",
        background: primaryBackground("ra"),
        1: unseen,
      }, {
        text: "Было весело минипулировать им как ребёнком?",
        background: primaryBackground("ra"),
      }, {
        text: "Или он был слишком наивен, для того чтобы ты насладился им?",
        background: primaryBackground("ra"),
      }, {
        text: "Шестой $1.",
        background: primaryBackground("laitela"),
        1: lesser,
      }, {
        text: "Я могу описать его только как $1.",
        background: primaryBackground("laitela"),
        1: paramount,
      }, {
        text: "Властный над всеми, никому не подчинённый.",
        background: primaryBackground("laitela"),
      }, {
        text: "Если ты не падаешь предо мной, ты обычно падаешь перед ним.",
        background: primaryBackground("laitela"),
      }, {
        text: "Я не могу охватить идеалы $1.",
        background: primaryBackground("laitela"),
        1: paramounta,
      }, {
        text: "Но, возможно, это - его уязвимость?",
        background: primaryBackground("laitela"),
      },
      "Достаточно воспоминаний об упавших.",
      {
        text: "И о тех, кто будет $1.",
        1: unseen
      }, {
        text: "Вернёмся к тому, как спотыкается $1.",
        1: destroyer
      }
    ],
  },
  galaxyGeneratorUnlock: {
    id: 7,
    lines: [
      "Что это?",
      { text: "$1?", 1: filament },
      { text: "Это ты создал все $1 вокруг себя?", 1: cluster },
      "Это был твой план? Очень, очень умно.",
      "Ты одурачил меня ненадолго.",
      { text: "Но я боюсь твои $1 оканчиваются здесь.", 1: ["Судьба", "Обязательства", "Цели"] }
    ],
  },
  galaxyGeneratorRifts: {
    id: 8,
    lines: [
      { text: "Я даю тебе выбор, $1.", 1: destroyer },
      { text: "Ограничь $1, или...", 1: filament },
      { text: "Разрушь 5 $1...", 1: inevitablov },
      "Погоди, как они называются?",
      { text: "$1?", 1: inevitable },
      { text: "Но Я ведь уже $1 их...", 1: unbroken }
    ],
  },
  galaxyGeneratorPhase1: {
    id: 9,
    lines: [
      "Было ли это действительным планом?",
      { text: "Медленно истощить $1?", 1: inevitablov }
    ],
  },
  galaxyGeneratorPhase4: {
    id: 10,
    lines: [
      "Дай мне время насладиться моим собственным высокомерием!"
    ],
  },
  end: {
    id: 11,
    lines: [
      "...",
      {
        text: "Ты! $1!",
        1: destroyer
      },
      "Ты хоть знаешь что ты заставил меня сотворить!",
      {
        text: "Я - соучастник в твоём $1!",
        1: mandate
      },
      "И из-за этого, ты... победил?",
      {
        text: "$1 страдание...",
        background: flashCelestial,
        1: forever,
      }, {
        text: "$1...",
        background: flashCelestial,
        1: battle,
      }, {
        text: "Наконец имеет победителя.",
        background: flashCelestial,
      }, {
        text: "Неотвратимое... $1.",
        background: flashCelestial,
        1: mandate,
      }, {
        text: "$1.", 1: destroyer,
        background: flashCelestial,
      }, {
        text: "Я надеюсь ты счастлив.",
        background: flashCelestial,
      }, {
        text: "Ты обрёк нас всех.",
        background: flashCelestial,
      },
    ],
  },
};
